import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { currentCompanyIdSelector } from '@/domain/router/routerLeafSelectors';

// A navigation outside a React event handler — the browser's back and forward buttons,
// navigate() called after an await — renders the route and updates the store's company
// one after the other, not together: the store's own router subscription writes the
// company, and the router notifies it and the route renderer in turn. For the render in
// between, a page and the permissions in the store belong to different companies, and a
// guard deciding on them would show a 404 or mount a page whose effects run with the
// wrong role. Both catch up in the same synchronous pass, so waiting out that render
// costs nothing visible.
//
// This compares the company being rendered with the one in the store instead of
// relying on the order in which the router notifies its subscribers or on how React
// batches updates. Neither is under our control, and React 18 with the router's
// v7_startTransition flag (kept off in RootRoute) reverses the order: the old page would
// get the new company.
export const useIsCompanyScopeBehind = (): boolean => {
  const { companyId: renderedCompanyId } = useParams();
  const scopeCompanyId = useSelector(currentCompanyIdSelector);

  return renderedCompanyId !== undefined && renderedCompanyId !== scopeCompanyId;
};
